import { render, staticRenderFns } from "./VueImageLightboxCarousel.vue?vue&type=template&id=b716720c&scoped=true"
import script from "./VueImageLightboxCarousel.vue?vue&type=script&lang=js"
export * from "./VueImageLightboxCarousel.vue?vue&type=script&lang=js"
import style0 from "./VueImageLightboxCarousel.vue?vue&type=style&index=0&id=b716720c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b716720c",
  null
  
)

export default component.exports